<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  mounted() {}
}
</script>
<style>
#app {
  background: #2957a5;
  /* height: auto !important; */
  width: 100%;
  /* overflow: hidden; */
  overflow-y: scroll;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}
input,
select,
textarea,
button {
  -webkit-appearance: none;
}
input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 100px white inset;
}
html {
  -webkit-overflow-scrolling: touch;
}
</style>
